import Axios from 'axios';
import React, { useState, useEffect } from 'react';

import { getDataWithComp, getAlert, deleteData, parseCurrency } from '../../../utils/SamuiUtils';
import { manageWhItemData } from '../../../utils/WarehouseUtils';

const CloseVansaleForWarehouseModal = ({ isVansaleCloseForWarehouse, hideVansaleCloseForWarehouse, pkId }) => {

    // ข้อมูล PKList
    const [pkDocNo, setPkDocNo] = useState("");
    const [deliveryLineName, setDeliveryLineName] = useState("");
    const [deliveryCarNo, setDeliveryCarNo] = useState("");
    const [docStatus, setDocStatus] = useState("");

    // รายการจำนวนสินค้าคงเหลือในรถ
    const [itemOnHandList, setItemOnHandList] = useState([]);

    // เลือกคลัง
    const [whDataList, setWhDataList] = useState([]);
    const [selectedWhId, setSelectedWhId] = useState(null);

    // Disabled ปุ่มหลังกดยืนยัน
    const [isDisabled, setIsDisabled] = useState(false);

    // Confirm Dialog สำหรับยืนยันการบันทึกรอบอีกนึง
    const [showConfirmDialog, setShowConfirmDialog] = useState(false);

    useEffect(() => {
        initialize();
    }, [pkId]);

    const initialize = async () => {
        try {
            // ข้อมูล PKList
            const pkDataList = await getDataWithComp('API_0801_PKList_H', `AND Doc_Id = ${pkId}`);
            if (pkDataList && pkDataList.length > 0) {
                const pkData = pkDataList[0];
                setPkDocNo(pkData.Doc_No);
                setDeliveryLineName(pkData.DL_LineName);
                setDeliveryCarNo(pkData.PK_Car_No);
                setDocStatus(pkData.Doc_Status);

                if (pkData.Doc_Status !== 2) {
                    setIsDisabled(true);
                }

                // รายการจำนวนสินค้าคงเหลือในรถ
                const itemOnHandList = await getDataWithComp('API_1101_WH_ITEM_ONHAND', `AND WH_Code = '${pkData.PK_Car_No}' ORDER BY Item_Code ASC`);
                if (itemOnHandList && itemOnHandList.length > 0) {
                    // กรองรายการที่มี Item_Onhand มากกว่า 0 และ Item_LastOnhand ไม่เป็น null
                    setItemOnHandList(itemOnHandList.filter(item => item.Item_Onhand > 0 && item.Item_LastOnhand != null));
                }
            }

            const whDataList = await getDataWithComp('Tb_Set_WH', `AND Flag_Vansale = 'N' AND WH_Status = 'Y' ORDER BY Flag_Vansale, WH_Name ASC`);
            if (whDataList && whDataList.length > 0) {
                setWhDataList(whDataList);
            }
        } catch (error) {
            getAlert('FAILED', error.message);
        }
    };

    // ฟังก์ชันเพิ่มและลดจำนวนสินค้า โดยเช็คไม่ให้เกินจำนวนคงเหลือ
    const handleItemIncrement = (index) => {
        setItemOnHandList(prevList =>
            prevList.map((item, i) =>
                i === index && item.Item_LastOnhand < item.Item_Onhand ?
                    { ...item, Item_LastOnhand: item.Item_LastOnhand + 1 } : item
            )
        );
    };

    const handleItemDecrement = (index) => {
        setItemOnHandList(prevList =>
            prevList.map((item, i) =>
                i === index && item.Item_LastOnhand > 0 ?
                    { ...item, Item_LastOnhand: item.Item_LastOnhand - 1 } : item
            )
        );
    };

    // ยืนยันการปิดงาน Vansale
    const handleConfirm = () => {
        setShowConfirmDialog(false);
        handleSubmit();
    };

    // ปิดงาน Vansale
    const handleSubmit = async () => {
        if (!selectedWhId && itemOnHandList.length > 0) {
            getAlert("FAILED", "ท่านยังไม่ได้เลือกคลัง");
            return;
        }

        try {
            // Disabled ปุ่มทันทีเมื่อระบบเริ่มทำงาน
            setIsDisabled(true);

            if (itemOnHandList && itemOnHandList.length > 0) {
                for (const itemData of itemOnHandList) {
                    let amountItemLost = parseCurrency(itemData.Item_Onhand) - parseCurrency(itemData.Item_LastOnhand);

                    // ทำการย้ายออก
                    await manageWhItemData(
                        itemData.Item_Id,         // Item ไอดีของสิ่งนั้นๆ
                        itemData.Item_Code,       // Item โค้ดของสิ่งนั้นๆ
                        itemData.Item_Name,       // ชื่อ Item นั้นๆ
                        itemData.WH_Id,           // WarehouseID ของไอเทม
                        "TO",                     // ประเภท เช่น IN/OUT/AI/AO/TI/TO
                        parseCurrency(itemData.Item_LastOnhand), // ค่าจำนวนที่กรอกจากหน้าจอ
                        pkId,                     // ไอดีเอกสาร
                        pkDocNo,                  // เลขเอกสาร
                        pkDocNo,                  // เลขเอกสารอ้างอิง
                        null                      // หมายเหตุ
                    );

                    // ทำการย้ายเข้า
                    await manageWhItemData(
                        itemData.Item_Id,         // Item ไอดีของสิ่งนั้นๆ
                        itemData.Item_Code,       // Item โค้ดของสิ่งนั้นๆ
                        itemData.Item_Name,       // ชื่อ Item นั้นๆ
                        selectedWhId,             // WarehouseID ของไอเทม
                        "TI",                     // ประเภท เช่น IN/OUT/AI/AO/TI/TO
                        parseCurrency(itemData.Item_LastOnhand), // ค่าจำนวนที่กรอกจากหน้าจอ
                        pkId,                     // ไอดีเอกสาร
                        pkDocNo,                  // เลขเอกสาร
                        pkDocNo,                  // เลขเอกสารอ้างอิง
                        null                      // หมายเหตุ
                    );

                    // ถ้ามีจำนวนสินค้าที่สูญหาย, เพิ่มการย้ายสินค้าเสียหายเป็นขั้นตอนสุดท้าย
                    if (amountItemLost > 0) {
                        await manageWhItemData(
                            itemData.Item_Id,     // Item ไอดีของสิ่งนั้นๆ
                            itemData.Item_Code,   // Item โค้ดของสิ่งนั้นๆ
                            itemData.Item_Name,   // ชื่อ Item นั้นๆ
                            itemData.WH_Id,       // WarehouseID ของไอเทม
                            "AO",                 // ประเภท เช่น IN/OUT/AI/AO/TI/TO
                            parseCurrency(amountItemLost), // ค่าจำนวนที่กรอกจากหน้าจอ
                            pkId,                 // ไอดีเอกสาร
                            pkDocNo,              // เลขเอกสาร
                            pkDocNo,              // เลขเอกสารอ้างอิง
                            "สินค้าเสียหาย"       // หมายเหตุ
                        );
                    }
                }
            }

            // ลบของทุกอย่างออกจากรถ
            const warehouse = await getDataWithComp('Tb_Set_WH', `AND Flag_Vansale = 'Y' AND WH_Status = 'Y' AND WH_Code = '${deliveryCarNo}'`);
            await deleteData('WH_ITEM_Onhand', `WHERE WH_Id = ${warehouse[0].WH_Id}`);

            // อัพเดทสถานะข้อมูลใน PKList_H
            const response = await Axios.post(`${process.env.REACT_APP_API_URL}/api/update-status-pk-list-h`, {
                doc_id: pkId,
                doc_status: 3
            }, {
                headers: { key: process.env.REACT_APP_ANALYTICS_KEY }
            });

            if (response.data.status === 'OK') {
                getAlert("OK", "ยืนยันการปิดงานสำเร็จ");
                hideVansaleCloseForWarehouse();
                setIsDisabled(false);
                initialize();
            }
        } catch (error) {
            setIsDisabled(false);
            getAlert("FAILED", "เกิดข้อผิดพลาดในการอัพเดทข้อมูล");
        }
    };

    return (
        <>
            <div
                className={`modal fade ${isVansaleCloseForWarehouse ? 'show' : ''}`}
                style={{ display: isVansaleCloseForWarehouse ? 'block' : 'none' }}
                tabIndex="-1"
                role="dialog"
            >
                <div className="modal-dialog modal-lg" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <div className="d-flex align-items-center">
                                <h4 className="card-title">ปิดงานคืนสต็อกคลัง</h4>
                            </div>
                            <button type="button" className="btn-close" onClick={hideVansaleCloseForWarehouse}></button>
                        </div>
                        <div className="modal-body" style={{ maxHeight: '700px', overflowY: 'auto', overflowX: 'hidden' }}>

                            <div className="row">
                                <div className="col-6 text-left">
                                    <h4 className="fw-bold text-black">ส่งสินค้า - {deliveryLineName}</h4>
                                </div>
                                <div className="col-6 text-end">
                                    <button className="btn btn-primary fw-bold btn-lg">
                                        ทะเบียนรถ - {deliveryCarNo}
                                    </button>
                                </div>
                            </div>

                            <br />

                            {/* ถ้า Doc_Status !== 2 ไม่ต้องแสดงรายละเอียดสินค้าที่คืนในคลัง */}
                            {docStatus === 2 && (
                                <>
                                    <div className="row d-flex align-items-center justify-content-between mb-4">
                                        <div className="col d-flex align-items-center">
                                            <h5 className="fw-bold text-danger" style={{ fontSize: "18px", marginBottom: 0 }}>จำนวนสินค้าคงเหลือในรถ</h5>
                                        </div>
                                        <div className="col d-flex justify-content-end align-items-center">
                                            <span
                                                className="fw-bold text-danger"
                                                style={{ fontSize: "18px", marginRight: "10px" }}
                                                hidden={itemOnHandList.length > 0 ? false : true}>
                                                เลือกคลัง
                                            </span>
                                            <select
                                                name="whId"
                                                className="form-select form-control"
                                                style={{ width: "50%" }}
                                                value={selectedWhId}
                                                onChange={(e) => setSelectedWhId(e.target.value)}
                                                hidden={itemOnHandList.length > 0 ? false : true}
                                                disabled={isDisabled}
                                            >
                                                <option value={''}>กรุณาเลือกคลัง</option>
                                                {whDataList.map((warehouse) => (
                                                    <option key={warehouse.WH_Id} value={warehouse.WH_Id}>
                                                        {warehouse.WH_Name}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>
                                    </div>

                                    <div className="row g-2 mb-4">
                                        {itemOnHandList.length > 0 ? (
                                            itemOnHandList.map((item, index) => (
                                                <div key={item.Item_Id || index} className="col-12 d-flex flex-column flex-md-row align-items-center">
                                                    <div className="card" style={{ width: "100%", border: "1px solid gray" }}>
                                                        <div className="card-body d-flex flex-column flex-md-row align-items-center">
                                                            <span className="me-3 fw-bold" style={{ whiteSpace: "normal", wordWrap: "break-word", width: "100%", display: "inline-block" }}>
                                                                {item.Item_Name}
                                                            </span>
                                                            <span className="me-3 fw-bold" style={{ whiteSpace: "normal", wordWrap: "break-word", width: "100%", display: "inline-block" }}>
                                                                คงเหลือในรถ <span className="fw-bold mb-3 text-center text-danger">{item.Item_Onhand}</span> ชิ้น
                                                            </span>
                                                            <div className="input-group text-end" style={{ width: "auto", flexShrink: 0 }}>
                                                                <button onClick={() => handleItemDecrement(index)} className="btn btn-outline-warning" style={{ width: "30px" }} disabled={isDisabled}>-</button>
                                                                <input
                                                                    type="text"
                                                                    className="form-control text-center"
                                                                    value={item.Item_LastOnhand || 0}
                                                                    min="0"
                                                                    style={{ width: "60px" }}
                                                                    readOnly
                                                                />
                                                                <button onClick={() => handleItemIncrement(index)} className="btn btn-outline-warning" style={{ width: "30px" }} disabled={isDisabled}>+</button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            ))
                                        ) : (
                                            <div className="col-12 text-center mt-4">
                                                <h5 className="fw-bold">ไม่พบรายการสินค้าที่คืนหรือในรถส่งสินค้า</h5>
                                            </div>
                                        )}
                                    </div>
                                </>
                            )}
                        </div>
                        <div className="modal-footer">
                            <button
                                className="btn btn-lg btn-danger"
                                onClick={hideVansaleCloseForWarehouse}
                            >
                                ย้อนกลับ
                            </button>
                            {docStatus === 2 && (
                                <button
                                    className="btn btn-lg btn-success"
                                    onClick={() => setShowConfirmDialog(true)}
                                    disabled={isDisabled}
                                >
                                    ยืนยันปิดงาน
                                </button>
                            )}
                        </div>
                    </div>
                </div >
            </div >

            {isVansaleCloseForWarehouse && <div className="modal-backdrop fade show"></div>}

            {/* Confirm Dialog */}
            {showConfirmDialog && (
                <div className="modal fade show" tabIndex="-1" style={{ display: 'block' }}>
                    <div className="modal-dialog modal-dialog-centered" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title fw-bold">ยืนยันการปิดงานคืนสต็อกคลัง</h5>
                                <button
                                    type="button"
                                    className="btn-close"
                                    onClick={() => setShowConfirmDialog(false)}
                                    aria-label="Close"
                                ></button>
                            </div>
                            <div className="modal-body">
                                <p>คุณแน่ใจว่าต้องการร ปิดงานคืนสต็อกคลัง หรือไม่?</p>
                            </div>
                            <div className="modal-footer">
                                <button
                                    type="button"
                                    className="btn btn-lg w-25 shadow text-white"
                                    style={{ backgroundColor: '#EF6C00', fontSize: '16px' }}
                                    onClick={handleConfirm}
                                >
                                    ยืนยัน
                                </button>
                                <button
                                    type="button"
                                    className="btn btn-lg w-25 shadow text-white"
                                    style={{ backgroundColor: 'red', fontSize: '16px' }}
                                    onClick={() => setShowConfirmDialog(false)}
                                >
                                    ยกเลิก
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default CloseVansaleForWarehouseModal;